import { methods, request } from "./base";
import environment from "src/constants/environment";

export const geolocationApis = {
  getStateList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/state_list",
      payload: data,
    }),
  getCityList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/city_list",
      payload: data,
    }),
};

export const locationApis = {
  getAddressList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/address_list",
      payload: data,
    }),
  updateAddress: async (payload: object) => {
    return await request({
      method: methods.POST,
      route: "/tests/update_address",
      payload,
    });
  },
  deleteAddress: async (payload: object) => {
    return await request({
      method: methods.POST,
      route: "/tests/delete_address",
      payload,
    });
  },
  getLocationFromLatLong: async (data?: any) => {
    const { lat, long } = data as { lat: number; long: number };
    await request({
      method: methods.GET,
      route: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${environment.GOOGLE_API_KEY}`,
      //payload: data,
      encrypt: false,
      priv: false,
    });
  },
  getLocationFromPincode: async (data?: any) => {
    const { pincode } = data as { pincode: string };
    await request({
      method: methods.GET,
      route: `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${environment.GOOGLE_API_KEY}`,
      //payload: data,
      encrypt: false,
      priv: false,
    });
  },
  pincodeValidation: async (data?: any) => {
    const { pincode } = data as { pincode: string };
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${environment.GOOGLE_API_KEY}`
      // {
      //   method: "get",
      //   headers: { "Content-Type": "application/json" },
      // }
    );
    // await request({
    //   method: methods.GET,
    //   route: `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${environment.GOOGLE_API_KEY}`,
    //   //payload: data,
    //   encrypt: false,
    //   priv: false,
    //   headers: { "Content-Type": "application/json" },
    // });
    const responseData = await response.json();
    return responseData;
  },
};
//export default geolocationApis;
